<div class="auth-spinner-container">
    <mat-spinner class="center" *ngIf="!stalled"></mat-spinner>
    <h1>{{ statusMessage | translate }}</h1>
    <div class="auth-actions" *ngIf="stalled">
        <button mat-raised-button color="primary" (click)="retry()">{{ '@retry' | translate }}</button>
        <button mat-raised-button (click)="signOut()">{{ '@logout' | translate }}</button>
    </div>
</div>
